import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuthStore } from './store/authStore'

// Pages
import LoginPage from './components/auth/LoginForm'
import RegisterPage from './components/auth/RegisterForm'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import ResetPasswordPage from './pages/auth/ResetPasswordPage'
import VerifyEmailPage from './pages/auth/VerifyEmailPage'
import Dashboard from './components/dashboard/Dashboard'
import Layout from './components/common/Layout'
import LeadsPage from './pages/leads/LeadsPage'
import ChannelsPage from './pages/channels/ChannelsPage'
import TrendsPage from './pages/trends/TrendsPage'
import CommentsPage from './pages/comments/CommentsPage'
import SettingsPage from './pages/settings/SettingsPage'
import IntelligencePage from './pages/intelligence/IntelligencePage'
import CiPage from './pages/content-intelligence/CiPage'
import AdminPage from './pages/admin/AdminPage'
import ScoutPage from './pages/channels/ScoutPage'
import ProjectsPage from './pages/projects/ProjectsPage'
import ProjectDetailPage from './pages/projects/ProjectDetailPage'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <>
    <Toaster position="top-right" />
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="channels" element={<ChannelsPage />} />
        <Route path="scout" element={<ScoutPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="trends" element={<TrendsPage />} />
        <Route path="comments" element={<CommentsPage />} />
        <Route path="intelligence" element={<IntelligencePage />} />
        <Route path="content-intelligence" element={<CiPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/:tab" element={<SettingsPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  )
}

export default App
